import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import DetailItem from './DetailItem';
import translate from '../../../commonComponents/translate';
import OrderProp from '../propTypes/orderProp';
import { formatDate } from '../../../services/dateUtilityFunctions';

function DetailBlock(props) {
  const { t, isOpportunity, item, isAcademy } = props;

  const { name, number, createdAt } = item;

  const pageInformation = useMemo(
    () => ({
      numberHeader: isOpportunity ? t('opportunity.number') : t('order.number'),
    }),
    [isOpportunity, t],
  );

  const trackingId = item?.tracking?.id || '-';
  const trackingLink = item?.tracking?.link || '-';

  return (
    <div className="header-container">
      {isOpportunity ? (
        <DetailItem
          header={t('opportunity.name')}
          text={name}
          textClass="highlight"
        />
      ) : null}
      <DetailItem
        header={pageInformation.numberHeader}
        text={number}
        textClass="highlight"
      />
      <DetailItem
        header={t('date')}
        text={formatDate(createdAt, 'MMM DD, YYYY')}
      />
      {!isOpportunity && !isAcademy ? (
        <DetailItem header={t('shop.tracking.number')} text={trackingId} />
      ) : null}
      {!isOpportunity && !isAcademy ? (
        <DetailItem
          header={t('shop.tracking_link')}
          text={trackingLink}
          isLink
        />
      ) : null}
    </div>
  );
}

DetailBlock.propTypes = {
  t: PropTypes.func.isRequired,
  isOpportunity: PropTypes.bool,
  isAcademy: PropTypes.bool,
  item: PropTypes.shape(OrderProp.propType).isRequired,
};

DetailBlock.defaultProps = {
  isOpportunity: false,
  isAcademy: false,
};

export default translate(DetailBlock);
